// extracted by mini-css-extract-plugin
export default {"bottomFooter":"index_bottomFooter_SYwBJ","bottomAd_box":"index_bottomAd_box_-b-NE","bottomAd":"index_bottomAd_AXDjk"};